module.exports = __webpack_public_path__ + "static/img/s4.42692758.png";